module.exports = __webpack_public_path__ + "img/beetle_leg3.ad246bfd.png";